export default __webpack_public_path__ + "static/media/icon_quest.b97271fe.png";